module.exports = __webpack_public_path__ + "img/live-receptionist.42b3b3df.svg";